import { queryClient } from './client'

export type QueryKey = readonly (string | number)[]

const sanitizeKeys = (keys: (string | number | undefined)[]): (string | number)[] =>
  keys.filter((key): key is string | number => key !== undefined && key !== null)

export const createQueryKey = ({ baseKey, keys }: { baseKey: QueryKey; keys: (string | number | undefined)[] }): QueryKey =>
  baseKey.concat(sanitizeKeys(keys))

export const concatQueryKey = (baseKey: QueryKey, keys: (string | number | undefined)[]): QueryKey => baseKey.concat(sanitizeKeys(keys))

export const AUTH_KEY: QueryKey = ['auth']
export const USER_KEY: QueryKey = ['user']

export const COMPANY_BASE_KEY: QueryKey = ['company']
export const WORKSPACE_KEY: QueryKey = ['workspace']
export const OPEX_BASE_KEY: QueryKey = ['opex']
export const SETTINGS_KEY: QueryKey = ['global-settings']
export const COGS_BASE_KEY: QueryKey = ['cogs']
export const REVENUES_BASE_KEY: QueryKey = ['revenues']
export const PERSONNEL_BASE_KEY: QueryKey = ['personnel']
export const FINANCIAL_MODEL_BASE_KEY: QueryKey = ['financial-model']
export const FINANCIAL_MODEL_SETTINGS_BASE_KEY: QueryKey = ['financial-model-settings']
export const FINANCIAL_MODEL_GLOBAL_SETTINGS_BASE_KEY: QueryKey = ['financial-model-global-settings']
export const REPORT_BASE_KEY: QueryKey = ['report']
export const FINANCIAL_TABLES_BASE_KEY: QueryKey = ['financial-tables']
export const FUNDRAISING_ADVISORY_BASE_KEY: QueryKey = ['fundraising-advisory']
export const TOTALS_KEY: QueryKey = ['totals']
export const OIC_KEY: QueryKey = ['oic']
export const EXPORT: QueryKey = ['export']
export const TWC_BASE_KEY: QueryKey = [...COGS_BASE_KEY, 'twc']
export const FIXED_ASSETS_BASE_KEY: QueryKey = ['fixed-assets']
export const VAT_BASE_KEY: QueryKey = ['vat']
export const PROVISIONS_BASE_KEY: QueryKey = ['provisions']
export const CORPORATE_TAXES_BASE_KEY: QueryKey = ['corporate-taxes']
export const OWC_BASE_KEY: QueryKey = ['owc']
export const CAPITAL_STRUCTURE_BASE_KEY: QueryKey = ['capital-structure']

export const invalidateGlobalsQueryKey = (queryKeys: QueryKey[]) => {
  queryKeys.forEach(queryKey => {
    queryClient.invalidateQueries({ queryKey: queryKey as any })
  })
}

export const resetGlobalQueryKey = (queryKeys: QueryKey[]) => {
  queryKeys.forEach(queryKey => {
    queryClient.resetQueries({ queryKey: queryKey as any })
  })
}
